// extracted by mini-css-extract-plugin
export var exit = "_4-3";
export var notificationContainer = "_4-1";
export var notificationStack = "_4-0";
export var shrinkFadeOut = "_4-4";
export var slideInUp = "_4-2";